// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__l7vwH","img":"Image_img__1qxru","skeleton":"Image_skeleton__qifmX"};